import React from 'react';
import Header from '../components/Header';
import FeedbackAdmin from '../components/FeedbackAdmin';

export default function FeedbackAdminPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="pt-16">
        <FeedbackAdmin />
      </main>
    </div>
  );
} 